import React, { Component } from 'react'
import _ from 'lodash'
import liffHelper from '../utils/liffHelper'
import utils from '../utils/utils'
import CeApi from '../lib/ce_api'

const liff = liffHelper.getLiff()

export default class LIFFWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      liff_id: "1653882163-AbYgw2G5",
      init_success: false,
      profile: {},
      login_channel_id: "",
      disabled_email_input: true,
      ce_user: {},
      button_fetching: true
    }
  }

  openLIFFWindow(url) {
    liffHelper.openWindow(url, false);
  }

  openLIFFWindowExternal(url) {
    liffHelper.openWindow(url, true);
  }

  async loginIfNot () {
    if (!await liff.isLoggedIn()) {
      await liff.login()
    }
  }

  initSalesIQ (widgetCode) {
    var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode:widgetCode, values:{},ready:function(){}};
    window.$zoho = $zoho
    var d=document;
    var s=d.createElement("script");
    s.type="text/javascript";
    s.id="zsiqscript";
    s.defer=true;
    s.src="https://salesiq.zoho.com/widget";
    var t=d.getElementsByTagName("script")[0];
    //t.parentNode.insertBefore(s,t);
    document.body.appendChild(s);
    //d.write("<div id='zsiqwidget'></div>");
    var divEle = document.createElement('div');
    divEle.id = "zsiqwidget"
    document.body.append(divEle);
  }

  async componentDidMount() {
    var that = this
    try {
      // liff id要從route抓
      let liffId = this.props.match.params.liff_id

      await liff.init({ liffId: liffId })

      if (!await liff.isLoggedIn()) {
        // set `redirectUri` to redirect the user to a URL other than the front page of your LIFF app.
        return await liff.login()
      }

      let decodeToken = await liff.getDecodedIDToken()
      if(!decodeToken.aud) throw new Error("loss login_channel_id")
      let login_channel_id = decodeToken.aud

      let profile = await liff.getProfile()
      if(!profile || !profile.userId) {
        window.alert("Oops! 從line官方獲取資料時失敗")
        return liff.closeWindow()
      }

      // let profile = {"userId":"U2b72b25be8a9fbe158ff6740b1650ab7","displayName":"阿康康","pictureUrl":"https://profile.line-scdn.net/0m0064285a72510a95740baf681b281f8f6adc33ebe203"}
      // let login_channel_id = "1653882163"

      let stateToBeSet = { init_success: true, login_channel_id, profile }

      let ceUserResult = await CeApi.getUserByLineId(profile.userId, login_channel_id)
      console.log(ceUserResult)
      if(!ceUserResult || !ceUserResult.result) {
        window.alert("獲取後台line個人資料失敗")
        return liff.closeWindow()
      }

      if(!_.isEmpty(ceUserResult.result))  {
        const ce_user = ceUserResult.result
        stateToBeSet.ce_user = ce_user

        let widgetCode = ""
        // if(liffId === "1653882163-lQ14265G") {
        //   widgetCode = "de883af2db8fc3407ccf2b69671fbb5837876ad46a71d9ee878eb085fb0de10c"
        // } else {
        //   widgetCode = "7bc268dc7cf3471744a38121eef448734f30f7472b1ccfd7360951b981d026c868409cad85ff645e864c60b52c277087"
        // }
        if(ce_user.widget_code) {
          widgetCode = ce_user.widget_code
        } else {
          window.alert("查無對應客服後台")
          return liff.closeWindow()
        }
        that.initSalesIQ(widgetCode)

        console.log("print widgetCode: ", widgetCode)

        let $zoho = window.$zoho
        $zoho.salesiq.ready=function() {
          $zoho.salesiq.visitor.name(ce_user.name)
          $zoho.salesiq.visitor.email(ce_user.email)
          $zoho.salesiq.visitor.contactnumber(ce_user.phone)
          $zoho.salesiq.chatbutton.texts([["online時上排訊息1234", "online時下排訊息"], ["offline時上排訊息", "offline時上排訊息"]])
          //$zoho.salesiq.visitor.question("123124");
          //$zoho.salesiq.chat.start();
          that.setState({ "button_fetching": false })
        }
      } else {
        window.alert("尚未設定個人資料, 請先到選單的加入我們頁面設定")
        return liff.closeWindow()
      }
      await this.setState(stateToBeSet)
    } catch (e) {
      console.log(e)
      window.alert("聊天窗口連接失敗")
    }


    return
    // widget自動展開 dirty
    // let retryTimes = 0
    // let retryTimesLimit = 10
    // function clickZs() {
    //   try {
    //     retryTimes += 1
    //     var link = document.getElementById('zsiq_float')
    //     link.click()
    //   } catch (e) {
    //     if(retryTimes <= retryTimesLimit) retryClickWidget()
    //   }
    // }
    // function retryClickWidget() {
    //   setTimeout(clickZs,20)
    // }
    // retryClickWidget()
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.button_fetching !== this.state.button_fetching && this.state.button_fetching === false) {
      let $zoho = window.$zoho
      $zoho.salesiq.floatwindow.visible("show")
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="page-content">
          <div className="container">
            <div className="row">

              <div className="col" />
              <div className="col-lg-6">
                <br />
                <br />
                <div className="jumbotron">
                  {
                    this.state.button_fetching
                    ?
                    <React.Fragment>
                      <p>客服聊天工具連線中</p>
                      <div className="spinner-border text-primary" style={{width: "6rem",  height: "6rem"}}  role="status" >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <p>正在聯繫客服人員，請稍後</p>
                    </React.Fragment>
                  }
                </div>
              </div>
              <div className="col" />

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/SalesIQ.js